import { downgradeComponent } from '@angular/upgrade/static';

import { DbmListComponent } from '../../../shared/components/dbm-components/dbm-list/dbm-list.component';
import { DbmMasterDetailListComponent } from '../../../shared/components/dbm-components/dbm-master-detail-list/dbm-master-detail-list.component';
import { DbmBoxListComponent } from '../../../shared/components/dbm-components/dbm-box-list/dbm-box-list.component';
import { DbmEditComponent } from '../../../shared/components/dbm-components/dbm-edit/dbm-edit.component';
import { DbmTimeframeComponent } from '../../../shared/components/dbm-components/dbm-timeframe/dbm-timeframe.component';
import { DbmAdditionalOptionsComponent } from '../../../shared/components/dbm-components/dbm-additional-options/dbm-additional-options.component';

export default angular.module('dbmSharedComponents', [])
    .directive('dbmList', downgradeComponent({ component: DbmListComponent }))
    .directive('dbmMasterDetailList', downgradeComponent({ component: DbmMasterDetailListComponent }))
    .directive('dbmBoxList', downgradeComponent({ component: DbmBoxListComponent }))
    .directive('dbmTimeframe', downgradeComponent({ component: DbmTimeframeComponent }))
    .directive('dbmAdditionalOptions', downgradeComponent({ component: DbmAdditionalOptionsComponent }))
    .directive('dbmEdit', downgradeComponent({ component: DbmEditComponent }))



// WEBPACK FOOTER //
// ./src/app/common/components/dbm-components/index.js